import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysMaterialOutSourcing ( props ) {

    return (

        <BasicCrudScreenType
            id="MomSysZvwOutSourcing"
            view="MomSysZvwOutSourcing"
            onInitialized = {(grid) => grid.selectionMode = "None"}
        />

    )

}

export default MomSysMaterialOutSourcing;
